var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [
      _vm._v(
        " " +
          _vm._s(
            _vm.users.id != null
              ? _vm.$t("settings.users.userEdit")
              : _vm.$t("settings.users.userNew")
          ) +
          " "
      )
    ]),
    _c(
      "div",
      { staticClass: "mt-3 elevation-12 grey lighten-4" },
      [
        _c(
          "v-tabs",
          { attrs: { centered: "", "icons-and-text": "" } },
          [
            _c(
              "v-tab",
              { key: "general" },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("settings.users.personalData")) + " "
                ),
                _c("v-icon", [_vm._v("account_box")])
              ],
              1
            ),
            _c(
              "v-tab",
              { key: "permissions" },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("settings.users.rolesAndPermissions")) +
                    " "
                ),
                _c("v-icon", [_vm._v("pan_tool")])
              ],
              1
            ),
            _c(
              "v-tab-item",
              { key: "general" },
              [
                _c(
                  "v-card",
                  [
                    _c(
                      "v-card-text",
                      [
                        _c(
                          "v-form",
                          {
                            ref: "form",
                            attrs: { "lazy-validation": "" },
                            model: {
                              value: _vm.formValid,
                              callback: function($$v) {
                                _vm.formValid = $$v
                              },
                              expression: "formValid"
                            }
                          },
                          [
                            _vm.$store.getters["isWnbUser"]
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "elevation-12",
                                    staticStyle: {
                                      "text-align": "center",
                                      display: "block",
                                      background: "white",
                                      "z-index": "1",
                                      position: "absolute",
                                      width: "300px",
                                      left: "50%",
                                      "margin-top": "50px",
                                      "margin-left": "-150px",
                                      padding: "50px"
                                    }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: "/img/wnb-logo-vertical.png",
                                        alt: "Logo WNB"
                                      }
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("settings.users.settingsInWnb")
                                        ) +
                                        " "
                                    ),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "primary",
                                        attrs: { block: "" },
                                        on: { click: _vm.redirectToWnb }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "settings.users.goToWnbButton"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "v-radio-group",
                              {
                                attrs: {
                                  disabled: _vm.$store.getters["isWnbUser"],
                                  mandatory: false,
                                  row: ""
                                },
                                model: {
                                  value: _vm.users.sex,
                                  callback: function($$v) {
                                    _vm.$set(_vm.users, "sex", $$v)
                                  },
                                  expression: "users.sex"
                                }
                              },
                              [
                                _c("v-radio", {
                                  attrs: {
                                    label: _vm.$t("global.mr"),
                                    value: 1
                                  }
                                }),
                                _c("v-radio", {
                                  attrs: {
                                    label: _vm.$t("global.ms"),
                                    value: 2
                                  }
                                }),
                                _c("v-radio", {
                                  attrs: {
                                    label: _vm.$t("global.notSet"),
                                    value: 0
                                  }
                                })
                              ],
                              1
                            ),
                            _c("v-text-field", {
                              attrs: {
                                disabled: _vm.$store.getters["isWnbUser"],
                                label:
                                  _vm.$t("settings.users.fields.name.name") +
                                  "*",
                                rules: _vm.users.nameRules
                              },
                              model: {
                                value: _vm.users.name,
                                callback: function($$v) {
                                  _vm.$set(_vm.users, "name", $$v)
                                },
                                expression: "users.name"
                              }
                            }),
                            _c("v-text-field", {
                              attrs: {
                                disabled: _vm.$store.getters["isWnbUser"],
                                label:
                                  _vm.$t("settings.users.fields.surname.name") +
                                  "*",
                                rules: _vm.users.surnameRules
                              },
                              model: {
                                value: _vm.users.surname,
                                callback: function($$v) {
                                  _vm.$set(_vm.users, "surname", $$v)
                                },
                                expression: "users.surname"
                              }
                            }),
                            _c("v-text-field", {
                              attrs: {
                                disabled: _vm.$store.getters["isWnbUser"],
                                label:
                                  _vm.$t("settings.users.fields.login.name") +
                                  "*",
                                rules: _vm.users.loginRules
                              },
                              model: {
                                value: _vm.users.login,
                                callback: function($$v) {
                                  _vm.$set(_vm.users, "login", $$v)
                                },
                                expression: "users.login"
                              }
                            }),
                            _c("v-text-field", {
                              attrs: {
                                disabled: _vm.$store.getters["isWnbUser"],
                                label:
                                  _vm.$t("settings.users.fields.email.name") +
                                  "*",
                                rules: _vm.users.emailRules
                              },
                              model: {
                                value: _vm.users.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.users, "email", $$v)
                                },
                                expression: "users.email"
                              }
                            }),
                            _c("v-checkbox", {
                              attrs: {
                                label: _vm.$t("settings.users.passwordByEmail")
                              },
                              model: {
                                value: _vm.passwordByMail,
                                callback: function($$v) {
                                  _vm.passwordByMail = $$v
                                },
                                expression: "passwordByMail"
                              }
                            }),
                            !_vm.passwordByMail
                              ? _c("v-text-field", {
                                  ref: "passwordInput",
                                  attrs: {
                                    label:
                                      _vm.$t(
                                        "settings.users.fields.password.name"
                                      ) + "*",
                                    placeholder:
                                      _vm.users.id != null
                                        ? _vm.$t(
                                            "settings.users.fields.password.noChange"
                                          )
                                        : "",
                                    rules: _vm.users.passwordRules,
                                    password: "",
                                    disabled: _vm.users.password_by_mail,
                                    type: "password"
                                  },
                                  model: {
                                    value: _vm.users.password,
                                    callback: function($$v) {
                                      _vm.$set(_vm.users, "password", $$v)
                                    },
                                    expression: "users.password"
                                  }
                                })
                              : _vm._e(),
                            !_vm.passwordByMail
                              ? _c("v-text-field", {
                                  ref: "passwordInputRepeat",
                                  attrs: {
                                    label:
                                      _vm.$t(
                                        "settings.users.fields.repeatPassword.name"
                                      ) + "*",
                                    placeholder:
                                      _vm.users.id != null
                                        ? _vm.$t(
                                            "settings.users.fields.repeatPassword.noChange"
                                          )
                                        : "",
                                    rules: _vm.users.repeatPasswordRules,
                                    disabled: _vm.users.password_by_mail,
                                    password: "",
                                    type: "password"
                                  },
                                  model: {
                                    value: _vm.users.repeatPassword,
                                    callback: function($$v) {
                                      _vm.$set(_vm.users, "repeatPassword", $$v)
                                    },
                                    expression: "users.repeatPassword"
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t(
                                      "settings.users.fields.integrationIdentifier.name"
                                    )
                                  },
                                  model: {
                                    value: _vm.users.integration_identifier,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.users,
                                        "integration_identifier",
                                        $$v
                                      )
                                    },
                                    expression: "users.integration_identifier"
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("v-autocomplete", {
                                  attrs: {
                                    items: _vm.availableSuperiors,
                                    label: _vm.$t(
                                      "settings.users.fields.superiorUser.name"
                                    )
                                  },
                                  model: {
                                    value: _vm.users.superior_user_id,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.users,
                                        "superior_user_id",
                                        $$v
                                      )
                                    },
                                    expression: "users.superior_user_id"
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("v-autocomplete", {
                                  attrs: {
                                    items: _vm.availableOrganisationStructures,
                                    label: _vm.$t(
                                      "settings.users.fields.organizationStructure.name"
                                    )
                                  },
                                  model: {
                                    value: _vm.users.organization_structure_id,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.users,
                                        "organization_structure_id",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "users.organization_structure_id"
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("v-autocomplete", {
                                  attrs: {
                                    items: _vm.availablePrivateVehicles,
                                    label: _vm.$t(
                                      "settings.users.fields.privateVehicle.name"
                                    )
                                  },
                                  model: {
                                    value: _vm.users.vehicle_private_id,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.users,
                                        "vehicle_private_id",
                                        $$v
                                      )
                                    },
                                    expression: "users.vehicle_private_id"
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("v-autocomplete", {
                                  attrs: {
                                    items: _vm.availableDefaultVehicles,
                                    label: _vm.$t(
                                      "settings.users.fields.defaultVehicle.name"
                                    )
                                  },
                                  model: {
                                    value: _vm.users.vehicle_default_id,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.users,
                                        "vehicle_default_id",
                                        $$v
                                      )
                                    },
                                    expression: "users.vehicle_default_id"
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t(
                                      "settings.users.fields.bankName.name"
                                    )
                                  },
                                  model: {
                                    value: _vm.users.bank_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.users, "bank_name", $$v)
                                    },
                                    expression: "users.bank_name"
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t(
                                      "settings.users.fields.bankAccount.name"
                                    )
                                  },
                                  model: {
                                    value: _vm.users.bank_account_number,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.users,
                                        "bank_account_number",
                                        $$v
                                      )
                                    },
                                    expression: "users.bank_account_number"
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t(
                                      "settings.users.fields.costCentre.name"
                                    )
                                  },
                                  model: {
                                    value: _vm.users.cost_centre,
                                    callback: function($$v) {
                                      _vm.$set(_vm.users, "cost_centre", $$v)
                                    },
                                    expression: "users.cost_centre"
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("location-ajax-select", {
                                  attrs: {
                                    label: _vm.$t("global.homeLocation"),
                                    placeholder: _vm.users.home_address_name,
                                    "select-model": _vm.users.home_address_id
                                  },
                                  on: {
                                    "update:selectModel": function($event) {
                                      return _vm.$set(
                                        _vm.users,
                                        "home_address_id",
                                        $event
                                      )
                                    },
                                    "update:select-model": function($event) {
                                      return _vm.$set(
                                        _vm.users,
                                        "home_address_id",
                                        $event
                                      )
                                    }
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("location-ajax-select", {
                                  attrs: {
                                    label: _vm.$t("global.workLocation"),
                                    placeholder: _vm.users.work_address_name,
                                    "select-model": _vm.users.work_address_id
                                  },
                                  on: {
                                    "update:selectModel": function($event) {
                                      return _vm.$set(
                                        _vm.users,
                                        "work_address_id",
                                        $event
                                      )
                                    },
                                    "update:select-model": function($event) {
                                      return _vm.$set(
                                        _vm.users,
                                        "work_address_id",
                                        $event
                                      )
                                    }
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("v-autocomplete", {
                                  attrs: {
                                    clearable: true,
                                    items: _vm.availableDelegationGroups,
                                    label: _vm.$t(
                                      "settings.users.fields.delegationRateGroup.name"
                                    )
                                  },
                                  model: {
                                    value: _vm.users.group_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.users, "group_id", $$v)
                                    },
                                    expression: "users.group_id"
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("v-select", {
                                  attrs: {
                                    items: _vm.languageChooser,
                                    label: _vm.$t(
                                      "settings.users.fields.language.name"
                                    )
                                  },
                                  model: {
                                    value: _vm.users.language,
                                    callback: function($$v) {
                                      _vm.$set(_vm.users, "language", $$v)
                                    },
                                    expression: "users.language"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-tab-item",
              { key: "permissions" },
              [
                _c(
                  "v-card",
                  [
                    _c(
                      "v-card-text",
                      [
                        _c("h2", [
                          _vm._v(
                            _vm._s(_vm.$t("settings.users.hasPermissions"))
                          )
                        ]),
                        _c(
                          "v-data-table",
                          {
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.hasAuthItems,
                              "hide-default-footer": "",
                              "footer-props": {
                                "items-per-page-options": [
                                  {
                                    text:
                                      "$vuetify.dataIterator.rowsPerPageAll",
                                    value: -1
                                  }
                                ]
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function(props) {
                                  return [
                                    _c("tr", [
                                      _c("td", { staticClass: "text-left" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              props.item.type == 2
                                                ? _vm.$t("global.permission")
                                                : _vm.$t("global.role")
                                            ) +
                                            " "
                                        )
                                      ]),
                                      _c("td", { staticClass: "text-left" }, [
                                        _vm._v(
                                          _vm._s(props.item.translated_name)
                                        )
                                      ]),
                                      _c("td", { staticClass: "text-left" }, [
                                        _vm._v(_vm._s(props.item.description))
                                      ]),
                                      _c(
                                        "td",
                                        { staticClass: "text-left" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "" },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.removeAuthItem(
                                                    props.item.name
                                                  )
                                                }
                                              }
                                            },
                                            [_c("v-icon", [_vm._v("clear")])],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ]
                                }
                              }
                            ])
                          },
                          [
                            _c(
                              "template",
                              { slot: "no-data" },
                              [
                                _c(
                                  "v-alert",
                                  {
                                    attrs: { color: "error", icon: "warning" }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("settings.users.noPermission")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "mt-5 md-0",
                            staticStyle: { "margin-bottom": "15px" }
                          },
                          [
                            _c("v-col", [
                              _c("h3", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("settings.users.addPermissions")
                                  )
                                )
                              ])
                            ]),
                            _c("v-spacer"),
                            _c(
                              "v-col",
                              { attrs: { cols: "3" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t("global.search"),
                                    "append-icon": "search",
                                    "hide-details": "",
                                    "single-line": ""
                                  },
                                  model: {
                                    value: _vm.search,
                                    callback: function($$v) {
                                      _vm.search = $$v
                                    },
                                    expression: "search"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("v-data-table", {
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.availableAuthItems,
                            search: _vm.search
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item",
                              fn: function(props) {
                                return [
                                  _c("tr", [
                                    _c("td", { staticClass: "text-left" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            props.item.type == 2
                                              ? _vm.$t("global.permission")
                                              : _vm.$t("global.role")
                                          ) +
                                          " "
                                      )
                                    ]),
                                    _c("td", { staticClass: "text-left" }, [
                                      _vm._v(_vm._s(props.item.translated_name))
                                    ]),
                                    _c("td", { staticClass: "text-left" }, [
                                      _vm._v(_vm._s(props.item.description))
                                    ]),
                                    _c(
                                      "td",
                                      { staticClass: "text-left" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: "" },
                                            nativeOn: {
                                              click: function($event) {
                                                return _vm.addAuthItem(
                                                  props.item.name
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("add")])],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "v-card",
          [
            _c(
              "v-card-actions",
              [
                _c("v-spacer"),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "blue darken-1", text: "" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.cancel()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      disabled:
                        !_vm.formValid || _vm.$store.getters["Ajax/loading"],
                      color: "blue darken-1",
                      text: ""
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.save()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.save")) + " ")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }